/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import * as _ from 'underscore';

class TypeSelection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sortedTypes: [],
			showTwitterWarning: false,
			//showTikTokWarning: false,
			//showYouTubeWarning: false,
			//showSnapchatWarning: false
		};

		this.sortTypes = this.sortTypes.bind(this);
		this.generateButton = this.generateButton.bind(this);

	}

	componentDidMount() {

		if (this.props.socials.types.length) {
			this.sortTypes(this.props.socials.types);
		}

		if (dataLayer && this.props.onboarding) {
			dataLayer.push({
				'event': 'onboarding-new-social'
			});
		}

	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.socials.types.length && !this.state.sortedTypes.length) {
			this.sortTypes(this.props.socials.types);
		}

	}

	sortTypes(types) {
		var constants = this.props.app.config.constants,
				sortOrder = [
					constants.POST_SVC_FACEBOOK,
					constants.POST_SVC_TWITTER,
					constants.POST_SVC_BLUESKY,
					constants.POST_SVC_PINTEREST,
					constants.POST_SVC_INSTAGRAM_BUSINESS,
					constants.POST_SVC_BLOGGER,
					constants.POST_SVC_LINKEDIN,
					constants.POST_SVC_THREADS,
					constants.POST_SVC_TIKTOK,
					constants.POST_SVC_GMYBUSINESS,
					constants.POST_SVC_DISCORD,
					constants.POST_SVC_REDDIT,
					constants.POST_SVC_WORDPRESS,
					constants.POST_SVC_YOUTUBE,
					constants.POST_SVC_TUMBLR,
					constants.POST_SVC_MASTODON,
					constants.POST_SVC_FEED,
					constants.POST_SVC_SLACK,
					constants.POST_SVC_STOCKTWITS,
					constants.POST_SVC_NEXTDOOR,
					constants.POST_SVC_SNAPCHAT
				],
				sorted = [];

		if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
			sortOrder = [
				constants.POST_SVC_FACEBOOK,
				constants.POST_SVC_BLUESKY,
				constants.POST_SVC_PINTEREST,
				constants.POST_SVC_INSTAGRAM_BUSINESS,
				constants.POST_SVC_BLOGGER,
				constants.POST_SVC_LINKEDIN,
				constants.POST_SVC_THREADS,
				constants.POST_SVC_TIKTOK,
				constants.POST_SVC_GMYBUSINESS,
				constants.POST_SVC_DISCORD,
				constants.POST_SVC_REDDIT,
				constants.POST_SVC_WORDPRESS,
				constants.POST_SVC_YOUTUBE,
				constants.POST_SVC_TUMBLR,
				constants.POST_SVC_MASTODON,
				constants.POST_SVC_FEED,
				constants.POST_SVC_SLACK,
				constants.POST_SVC_STOCKTWITS,
				constants.POST_SVC_NEXTDOOR,
				constants.POST_SVC_TWITTER,
				constants.POST_SVC_SNAPCHAT
			];
		}

		if (this.state.sortedTypes.length === 0) {
			if (types.length) {
				for (let i = 0; i < sortOrder.length; ++i) {
					for (let j = 0; j < types.length; ++j) {
						if (sortOrder[i] == types[j].id && this.props.hideTypes.indexOf(sortOrder[i]) === -1) {
							sorted.push(types[j]);
						}
					}
				}
			}

			this.setState({
				sortedTypes: sorted
			});
		}

	}

	generateButton(type, i) {
		let index = ConstantMixin.getIconIndexByCode(type.id),
			Icon = IconFactory[index],
			directConnect = (this.props.context === 'config' || this.props.context === 'posting' || this.props.context === 'posting-tool') ? true : false,
			constants = this.props.app.config.constants;

		// Ignore the Test service
		if (parseInt(type.id) === 0) {
			return;
		}

		// Ignore output feed if the user is a client
		if (parseInt(type.id) === constants.POST_SVC_FEED && this.props.user.detail.isClient) {
			return;
		}

		if (_.findWhere(this.props.socials.counts, {type: type.id}) === undefined) {
			directConnect = true;
		}

		if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
			if (type.id == constants.POST_SVC_TWITTER) {
				return (
						<li className="social-connector"
								key={i}
								data-serviceid={type.id}
								data-direct={directConnect}
								onMouseOver={() => {
									this.setState({
										showTwitterWarning: true
									});
								}}
								onMouseOut={() => {
									this.setState({
										showTwitterWarning: false
									});
								}}>
							<Icon large={true} inactive={true} round={true}/>
							{(this.state.showTwitterWarning) ? (
									<div className="twitter-warning">
										X (Twitter) is currently unavailable
									</div>
							) : null}
						</li>
				);
			}

			if (this.props.twitterCount >= 1 && type.id == constants.POST_SVC_TWITTER) {
				return (
					<li className="social-connector" key={i} data-serviceid={type.id}
							data-direct={directConnect} title={"This output is not available"}>
						<Icon large={true} inactive={true} round={true}/>
					</li>
				);
			}
		}

		if (type.id === constants.POST_SVC_FACEBOOK) {
			return (
				<li className="social-connector"
					key={i}
					data-serviceid={type.id}
					data-subtype={constants.FB_SUBTYPE_PAGE}
					data-direct={directConnect}
					onClick={ConnectMixin.connectService.bind(this)}
					role="button"
					aria-label={type.name}
					title={type.name}>
					<Icon large={true} round={true}/>
				</li>
			);
		}

		if (type.id === constants.POST_SVC_MASTODON && directConnect) {
			return (
			<li className="social-connector" key={i} data-serviceid={type.id} data-direct={false} onClick={() => {
					if (this.props.user.perms.resources.outputsAvailable == 0) {
						this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'social_modal');
						return;
					}
						this.props.switchView('providehandle');
					}} role="button" aria-label={type.name} title={type.name}>
						<Icon large={true} round={true}/>
					</li>
			);
		}

		if (type.id === constants.POST_SVC_BLUESKY && directConnect) {
			return (
			<li className="social-connector" key={i} data-serviceid={type.id} data-direct={false} onClick={() => {
					if (this.props.user.perms.resources.outputsAvailable == 0) {
						this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'social_modal');
						return;
					}
						this.props.switchView('blueskycreds');
					}} role="button" aria-label={type.name} title={type.name}>
						<Icon large={true} round={true}/>
					</li>
			);
		}

		// if (type.id === constants.POST_SVC_TIKTOK && ['input', 'list-add', 'list'].indexOf(this.props.context) !== -1) {
		// 	return (
		// 			<li className="social-connector"
		// 					key={i}
		// 					data-serviceid={type.id}
		// 					data-direct={directConnect}
		// 					onMouseOver={() => {
		// 						this.setState({
		// 							showTikTokWarning: true
		// 						});
		// 					}}
		// 					onMouseOut={() => {
		// 						this.setState({
		// 							showTikTokWarning: false
		// 						});
		// 					}}>
		// 				<Icon large={true} inactive={true} round={true}/>
		// 				{(this.state.showTikTokWarning) ? (
		// 						<div className="twitter-warning">
		// 							Tiktok is not available for feeds
		// 						</div>
		// 				) : null}
		// 			</li>
		// 	);
		// }

		// if (type.id === constants.POST_SVC_YOUTUBE && ['input', 'list-add', 'list'].indexOf(this.props.context) !== -1) {
		// 	return (
		// 			<li className="social-connector"
		// 					key={i}
		// 					data-serviceid={type.id}
		// 					data-direct={directConnect}
		// 					onMouseOver={() => {
		// 						this.setState({
		// 							showYouTubeWarning: true
		// 						});
		// 					}}
		// 					onMouseOut={() => {
		// 						this.setState({
		// 							showYouTubeWarning: false
		// 						});
		// 					}}>
		// 				<Icon large={true} inactive={true} round={true}/>
		// 				{(this.state.showYouTubeWarning) ? (
		// 						<div className="twitter-warning">
		// 							YouTube is not available for feeds
		// 						</div>
		// 				) : null}
		// 			</li>
		// 	);
		// }

		// if (type.id === constants.POST_SVC_SNAPCHAT && ['input', 'list-add', 'list'].indexOf(this.props.context) !== -1) {
		// 	return (
		// 			<li className="social-connector"
		// 					key={i}
		// 					data-serviceid={type.id}
		// 					data-direct={directConnect}
		// 					onMouseOver={() => {
		// 						this.setState({
		// 							showSnapchatWarning: true
		// 						});
		// 					}}
		// 					onMouseOut={() => {
		// 						this.setState({
		// 							showSnapchatWarning: false
		// 						});
		// 					}}>
		// 				<Icon large={true} inactive={true} round={true}/>
		// 				{(this.state.showSnapchatWarning) ? (
		// 						<div className="twitter-warning">
		// 							Snapchat is not available for feeds
		// 						</div>
		// 				) : null}
		// 			</li>
		// 	);
		// }

		// TODO: set up permissions and actions for clicking on a service not in your subscription
		//
		let tipLabel = type.name;
		if (tipLabel.match('GMy')) {
			tipLabel = 'Google Business Profile';
		} else if (tipLabel.match('InstagramBusiness')) {
			tipLabel = 'Instagram Business or Creator';
		} else if (tipLabel.match('Twitter')) {
			tipLabel = 'X (Twitter)';
		} else if (tipLabel.match(/youtube/i)) {
			tipLabel = 'YouTube';
		}

		return (
			<li className="social-connector" key={i} data-serviceid={type.id}
					data-direct={directConnect} onClick={ConnectMixin.connectService.bind(this)}
					role="button" aria-label={tipLabel} title={tipLabel}>
				<Icon large={true} round={true}/>
			</li>
		);
	}

	render() {

		let containerClass = 'social-connector-wrapper clearfix',
			onboardingMain = this.state.sortedTypes.slice(0, 10),
			onboardingOptional = this.state.sortedTypes.slice(10);

		if (this.props.extraClasses !== '') {
			containerClass += ' ' + this.props.extraClasses;
		}

		return (
			<div className={containerClass}>
				<ul className="social-connector-list">
					{this.state.sortedTypes.map(function (type, i) {
						return this.generateButton(type, i);
					}, this)}
				</ul>
			</div>
		);
	}
}

TypeSelection.displayName = "TypeSelection";

TypeSelection.propTypes = {
	types: PropTypes.array,
	switchView: PropTypes.func,
	userPerms: PropTypes.object,
	setModal: PropTypes.func,
	recordPath: PropTypes.func,
	router: PropTypes.object,
	redirect: PropTypes.string,
	extraClasses: PropTypes.string,
	trialEligible: PropTypes.bool
};

TypeSelection.defaultProps = {
	types: [],
	switchView: null,
	userPerms: {},
	setModal: null,
	recordPath: null,
	router: null,
	redirect: '',
	onboarding: null,
	extraClasses: '',
	hideTypes: [],
	trialEligible: false
};

export default SubscriptionModule(TypeSelection);
